import Corporation          from "../../../domain/corporation/Corporation";
import CorporationApplicant from "../../../domain/corporation/CorporationApplicant";
import Address              from "../../../domain/fundamentals/address/Address";
import Name                 from "../../../domain/fundamentals/name/Name";
import {
  ACTION_TYPE,
  CorporationAction,
  SetCorporationAction,
  SetCorporationAddressBuildingAction,
  SetCorporationAddressCityAction,
  SetCorporationAddressPostalCodeAction,
  SetCorporationAddressPrefectureAction,
  SetCorporationAddressStreetAction,
  SetCorporationApplicantEmailAction,
  SetCorporationApplicantFirstNameAction,
  SetCorporationApplicantFirstNameKanaAction,
  SetCorporationApplicantLastNameAction,
  SetCorporationApplicantLastNameKanaAction,
  SetCorporationNameAction,
  SetCorporationNameKanaAction,
  SetCorporationPhoneAction
}                           from "./CorporationAction";

const reduceCorporation = (action: SetCorporationAction): Corporation => {
  return action.corporation;
};

const reduceCorporationName = (state: Corporation, action: SetCorporationNameAction): Corporation => {
  return new Corporation(
    state.id,
    action.name,
    state.nameKana,
    state.phone,
    state.applicant,
    state.address
  );
};

const reduceCorporationNameKana = (state: Corporation, action: SetCorporationNameKanaAction): Corporation => {
  return new Corporation(
    state.id,
    state.name,
    action.nameKana,
    state.phone,
    state.applicant,
    state.address
  );
};

const reduceCorporationPhone = (state: Corporation, action: SetCorporationPhoneAction): Corporation => {
  return new Corporation(
    state.id,
    state.name,
    state.nameKana,
    action.phone,
    state.applicant,
    state.address
  );
};

const reduceCorporationApplicantLastName = (state: Corporation, action: SetCorporationApplicantLastNameAction): Corporation => {
  return new Corporation(
    state.id,
    state.name,
    state.nameKana,
    state.phone,
    new CorporationApplicant(
      new Name(
        action.lastName,
        state.applicant.name.firstName,
        state.applicant.name.lastNameKana,
        state.applicant.name.firstNameKana
      ),
      state.applicant.email
    ),
    state.address
  );
};

const reduceCorporationApplicantFirstName = (state: Corporation, action: SetCorporationApplicantFirstNameAction): Corporation => {
  return new Corporation(
    state.id,
    state.name,
    state.nameKana,
    state.phone,
    new CorporationApplicant(
      new Name(
        state.applicant.name.lastName,
        action.firstName,
        state.applicant.name.lastNameKana,
        state.applicant.name.firstNameKana
      ),
      state.applicant.email
    ),
    state.address
  );
};

const reduceCorporationApplicantLastNameKana = (state: Corporation, action: SetCorporationApplicantLastNameKanaAction): Corporation => {
  return new Corporation(
    state.id,
    state.name,
    state.nameKana,
    state.phone,
    new CorporationApplicant(
      new Name(
        state.applicant.name.lastName,
        state.applicant.name.firstName,
        action.lastNameKana,
        state.applicant.name.firstNameKana
      ),
      state.applicant.email
    ),
    state.address
  );
};

const reduceCorporationApplicantFirstNameKana = (state: Corporation, action: SetCorporationApplicantFirstNameKanaAction): Corporation => {
  return new Corporation(
    state.id,
    state.name,
    state.nameKana,
    state.phone,
    new CorporationApplicant(
      new Name(
        state.applicant.name.lastName,
        state.applicant.name.firstName,
        state.applicant.name.lastNameKana,
        action.firstNameKana
      ),
      state.applicant.email
    ),
    state.address
  );
};

const reduceCorporationApplicantEmail = (state: Corporation, action: SetCorporationApplicantEmailAction): Corporation => {
  return new Corporation(
    state.id,
    state.name,
    state.nameKana,
    state.phone,
    new CorporationApplicant(
      state.applicant.name,
      action.email
    ),
    state.address
  );
};

const reduceCorporationAddressPostalCode = (state: Corporation, action: SetCorporationAddressPostalCodeAction): Corporation => {
  return new Corporation(
    state.id,
    state.name,
    state.nameKana,
    state.phone,
    state.applicant,
    new Address(
      action.postalCode,
      state.address.prefecture,
      state.address.city,
      state.address.street,
      state.address.building
    )
  );
};

const reduceCorporationAddressPrefecture = (state: Corporation, action: SetCorporationAddressPrefectureAction): Corporation => {
  return new Corporation(
    state.id,
    state.name,
    state.nameKana,
    state.phone,
    state.applicant,
    new Address(
      state.address.postalCode,
      action.prefecture,
      state.address.city,
      state.address.street,
      state.address.building
    )
  );
};

const reduceCorporationAddressCity = (state: Corporation, action: SetCorporationAddressCityAction): Corporation => {
  return new Corporation(
    state.id,
    state.name,
    state.nameKana,
    state.phone,
    state.applicant,
    new Address(
      state.address.postalCode,
      state.address.prefecture,
      action.city,
      state.address.street,
      state.address.building
    )
  );
};

const reduceCorporationAddressStreet = (state: Corporation, action: SetCorporationAddressStreetAction): Corporation => {
  return new Corporation(
    state.id,
    state.name,
    state.nameKana,
    state.phone,
    state.applicant,
    new Address(
      state.address.postalCode,
      state.address.prefecture,
      state.address.city,
      action.street,
      state.address.building
    )
  );
};

const reduceCorporationAddressBuilding = (state: Corporation, action: SetCorporationAddressBuildingAction): Corporation => {
  return new Corporation(
    state.id,
    state.name,
    state.nameKana,
    state.phone,
    state.applicant,
    new Address(
      state.address.postalCode,
      state.address.prefecture,
      state.address.city,
      state.address.street,
      action.building
    )
  );
};

const corporationReducer = (state: Corporation = new Corporation(), action: CorporationAction): Corporation => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_CORPORATION:
      return reduceCorporation(action as SetCorporationAction);
    case ACTION_TYPE.SET_CORPORATION_NAME:
      return reduceCorporationName(state, action as SetCorporationNameAction);
    case ACTION_TYPE.SET_CORPORATION_NAME_KANA:
      return reduceCorporationNameKana(state, action as SetCorporationNameKanaAction);
    case ACTION_TYPE.SET_CORPORATION_PHONE:
      return reduceCorporationPhone(state, action as SetCorporationPhoneAction);
    case ACTION_TYPE.SET_CORPORATION_APPLICANT_LAST_NAME:
      return reduceCorporationApplicantLastName(state, action as SetCorporationApplicantLastNameAction);
    case ACTION_TYPE.SET_CORPORATION_APPLICANT_FIRST_NAME:
      return reduceCorporationApplicantFirstName(state, action as SetCorporationApplicantFirstNameAction);
    case ACTION_TYPE.SET_CORPORATION_APPLICANT_LAST_NAME_KANA:
      return reduceCorporationApplicantLastNameKana(state, action as SetCorporationApplicantLastNameKanaAction);
    case ACTION_TYPE.SET_CORPORATION_APPLICANT_FIRST_NAME_KANA:
      return reduceCorporationApplicantFirstNameKana(state, action as SetCorporationApplicantFirstNameKanaAction);
    case ACTION_TYPE.SET_CORPORATION_APPLICANT_EMAIL:
      return reduceCorporationApplicantEmail(state, action as SetCorporationApplicantEmailAction);
    case ACTION_TYPE.SET_CORPORATION_ADDRESS_POSTAL_CODE:
      return reduceCorporationAddressPostalCode(state, action as SetCorporationAddressPostalCodeAction);
    case ACTION_TYPE.SET_CORPORATION_ADDRESS_PREFECTURE:
      return reduceCorporationAddressPrefecture(state, action as SetCorporationAddressPrefectureAction);
    case ACTION_TYPE.SET_CORPORATION_ADDRESS_CITY:
      return reduceCorporationAddressCity(state, action as SetCorporationAddressCityAction);
    case ACTION_TYPE.SET_CORPORATION_ADDRESS_STREET:
      return reduceCorporationAddressStreet(state, action as SetCorporationAddressStreetAction);
    case ACTION_TYPE.SET_CORPORATION_ADDRESS_BUILDING:
      return reduceCorporationAddressBuilding(state, action as SetCorporationAddressBuildingAction);
  }
};

export default corporationReducer;
